






















import Vue from 'vue'
import moment from 'moment'
import CardHistoryItem from './CardHistoryItem.vue'
import OptionHistoryItem from './OptionHistoryItem.vue'
import FinishHistoryItem from './FinishHistoryItem.vue'
import { HistoryItem } from '@/models/scripts'
import { HistoryItemType } from '@/constants/scripts'

interface Computed {
  isCardHistory: boolean
  isOptionHistory: boolean
  isFinishHistory: boolean
  isReturnedHistory: boolean
}

interface Props {
  item: HistoryItem
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    CardHistoryItem,
    OptionHistoryItem,
    FinishHistoryItem,
  },
  props: {
    item: {
      required: true,
    },
  },
  computed: {
    isCardHistory(): boolean {
      return this.item.type === HistoryItemType.CardRequestedData
    },
    isOptionHistory(): boolean {
      return this.item.type === HistoryItemType.OptionChoosedData
    },
    isFinishHistory(): boolean {
      return this.item.type === HistoryItemType.ScriptFinishedData
    },
    isReturnedHistory(): boolean {
      return this.item.type === HistoryItemType.ReturnedToCardData
    },
  },
  filters: {
    moment(date: number) {
      return moment.unix(date).format('HH:mm')
    },
  },
})
